import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Payload } from '../../Model/core';
import { BookButton } from './bookButton';
import { Matrix } from './matrix';
import { autobind } from './autobind';
import { debounceMethod } from './debonce';
import { toggleClass } from './util';

// Detta är inget som kommer förändras, lägg utanför props och state.
export let payload: Payload;

export let mobile = false;

interface MainComponentProps {
    rootElement: HTMLElement;
}

interface MainComponentState {
    mobile: boolean;
}

class MainComponent extends React.Component<MainComponentProps, MainComponentState> {

    constructor(props: MainComponentProps) {
        super(props);
        this.state = {
            mobile: false
        };
    }

    checkSize() {
        let w = document.documentElement.clientWidth;
        let _mobile = w <= 768;

        toggleClass(this.props.rootElement, 'cm-mobile', _mobile);

        this.setState({ mobile: _mobile });
        mobile = _mobile;
    }

    componentDidMount() {
        window.addEventListener('resize', () => this.checkSize());
        this.checkSize();
    }

    render() {
        return (
            <div className='cm-main-container'>
                {!payload.FormView && <>
                    <BookButton title='Boka nu – det är kostnadsfritt!' />
                </>}

                <h3>Program</h3>
                <Matrix />

                {!payload.FormView && <>
                    <BookButton title='Anmäl dig kostnadsfritt!' />
                </>}
            </div>
        );
    }
}


export const renderInto = (element: string, payloadData: Payload) => {
    payload = payloadData;
    console.log('payload', payload);

    const elm = document.querySelector(element) as HTMLElement;

    if (elm) {
        ReactDOM.render(<MainComponent rootElement={elm} />, elm);
    }
};
